import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"

function Seo({ description, lang, meta, title, keywords, image, seoTitle }) {
  const { site, logo } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            keywords
            author
          }
        }
        logo: file(relativePath: { eq: "default-og-image.png" }) {
          childImageSharp {
            resize(
              fit: COVER
              height: 630
              width: 1200
              quality: 90
              toFormat: JPG
            ) {
              src
              width
              height
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle =
    (title && title.replace(/^\w/, c => c.toUpperCase())) ||
    site.siteMetadata?.title
  const defaultKeywords = keywords || site.siteMetadata.keywords
  const ogImage = image || logo.childImageSharp.resize

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={seoTitle ? seoTitle : defaultTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: defaultKeywords,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: ogImage.src,
        },
        {
          property: "og:image:width",
          content: `${ogImage.width}`,
        },
        {
          property: "og:image:height",
          content: `${ogImage.height}`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <script type="application/ld+json">
        {`
{
"@context": "https://schema.org/",
"@type": "Dentist",
"name": "Chamberlain Dental",
"address": {
"@type": "PostalAddress",
"streetAddress": "555 S Hercules Avenue #403",
"addressLocality": "Clearwater",
"addressRegion": "FL",
"postalCode": "33764"
},
"email": "office@chamberlaindental.com",
"telePhone": "727-441-6060",
"url": "Dentist Clearwater Fl | Family Dentistry – Chamberlain Dental",
"geo": {
"@type": "GeoCoordinates",
"latitude": "27.9592179",
"longitude": "-82.7542872"
}
}`}
      </script>
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default Seo
